import { NgModule } from '@angular/core';

import { SharedModule } from 'projects/ProjetoBaseAngular/app/shared.module';
import { ReportModule } from '../../report/report.module';
import { RelRepasseSimplificadoComponent } from './rel-repasse-simplificado.component';

@NgModule({
  imports: [
    SharedModule,
    ReportModule
  ],
  declarations: [
    RelRepasseSimplificadoComponent,
  ]
})
export class RelRepasseSimplificadoModule { }
